var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import * as React from 'react';
import { styled } from '@creditas-ui/system';
import { Box } from '@creditas-ui/layout';
import { base, sizes } from './SpinnerIndeterminate.style';
var SpinnerIndeterminateElement = styled(Box.withComponent('span'))(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), base, sizes);
/**
 * Primary UI component for user interaction
 */

var SpinnerIndeterminate = function SpinnerIndeterminate(_ref) {
  var accessibilityMessage = _ref.accessibilityMessage,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, ["accessibilityMessage", "size"]);

  return /*#__PURE__*/React.createElement(SpinnerIndeterminateElement, _extends({}, props, {
    size: size
  }), /*#__PURE__*/React.createElement("span", null, accessibilityMessage));
};

export { SpinnerIndeterminate };